import { __decorate, __extends } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
var CountdownTemplate = /** @class */ (function (_super) {
    __extends(CountdownTemplate, _super);
    function CountdownTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountdownTemplate.prototype.toggleAnimation = function (type, props) {
        switch (type) {
            case 'minute':
                return props.seconds === '59';
            case 'hour':
                return props.minutes === '59' && props.seconds === '59';
            case 'day':
                return props.hours === '59' && props.minutes === '59' && props.seconds === '59';
            case 'second':
                return !(props.days === '00' && props.hours === '00' && props.seconds === '00');
            default:
                return false;
        }
    };
    __decorate([
        Prop({
            default: function () {
                return {
                    days: '00',
                    hours: '00',
                    minutes: '00',
                    seconds: '00'
                };
            }
        })
    ], CountdownTemplate.prototype, "props", void 0);
    __decorate([
        Prop()
    ], CountdownTemplate.prototype, "countdownObject", void 0);
    __decorate([
        Prop()
    ], CountdownTemplate.prototype, "isHourCount", void 0);
    CountdownTemplate = __decorate([
        Component
    ], CountdownTemplate);
    return CountdownTemplate;
}(Vue));
export default CountdownTemplate;
